/**
 * Billing period toggle (monthly / yearly).
 * Drives every pricing card on the page via data-* attrs, so the same
 * pricingCards.twig partial works on the homepage and the pricing page.
 * No-op when no .billing-toggle is present.
 */
(function () {
  var wraps = document.querySelectorAll('.billing-toggle');
  if (!wraps.length) return;

  function applyPeriod(period) {
    var annual = period === 'annual';
    document.querySelectorAll('.billing-toggle [data-billing]').forEach(function (o) {
      var on = o.dataset.billing === period;
      o.classList.toggle('is-active', on);
      o.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('[data-price-monthly]').forEach(function (el) {
      el.textContent = annual ? el.dataset.priceAnnual : el.dataset.priceMonthly;
    });
    document.querySelectorAll('[data-sub-monthly]').forEach(function (el) {
      el.textContent = annual ? el.dataset.subAnnual : el.dataset.subMonthly;
    });
    document.querySelectorAll('[data-cta-plus]').forEach(function (el) {
      el.href = annual ? el.dataset.hrefAnnual : el.dataset.hrefMonthly;
    });
    // Announce the silent price/CTA rewrite to assistive tech.
    var plus = document.querySelector('[data-price-monthly]');
    var price = plus ? (annual ? plus.dataset.priceAnnual : plus.dataset.priceMonthly) : '';
    document.querySelectorAll('[data-billing-status]').forEach(function (s) {
      s.textContent = (annual ? 'Yearly' : 'Monthly') + ' billing selected. Plus is ' + price + ' per month.';
    });
  }

  wraps.forEach(function (wrap) {
    wrap.querySelectorAll('[data-billing]').forEach(function (o) {
      o.addEventListener('click', function () { applyPeriod(o.dataset.billing); });
    });
  });
})();
